import adminInstructionReducer from '@/admin/pages/instruction/Reducer';
import profileReducer from '@/admin/pages/profile/Reducer';
import adminPlaylistReducer from '@/admin/pages/quiz/Reducer';
import episodesReducer from '@/admin/pages/studyGoBridgeEpisodes/Reducer';
import episodeDetailsReducer from '@/admin/pages/studyGoEpisodeDetails/Reducer';
import roomDetailsReducer from '@/admin/pages/studyGoRoomDetails/Reducer';
import subjectDetailsReducer from '@/admin/pages/subjectDetails/Reducer';
import subjectsReducer from '@/admin/pages/subjects/Reducer';
import topicsReducer from '@/admin/pages/topics/Reducer';

import manageCategoryReducer from '@/admin/components/modals/manageCategory/Reducer';
import manageDifficultyReducer from '@/admin/components/modals/manageDifficulty/Reducer';
import manageEpisodeReducer from '@/admin/components/modals/manageEpisodeModal/Reducer';
import managePlaylistReducer from '@/admin/components/modals/managePlaylist/Reducer';
import manageSubcategoryReducer from '@/admin/components/modals/manageSubcategory/Reducer';
import manageSubjectReducer from '@/admin/components/modals/manageSubject/Reducer';
import manageTopicReducer from '@/admin/components/modals/manageTopic/Reducer';
import sidebarReducer from '@/admin/components/sideBar/Reducer';
import addWysiwygAnswerModalReducer from '@/admin/components/wysiwyg/addAnswer/Reducer';
import addWysiwygFormulaModalReducer from '@/admin/components/wysiwyg/addFormula/Reducer';
import addWysiwygImageModalReducer from '@/admin/components/wysiwyg/addImage/Reducer';
import addWysiwygVideoModalReducer from '@/admin/components/wysiwyg/addVideo/Reducer';
import notificationReducer from '@/components/notification/Reducer';
import notificationsReducer from '@/components/notifications/Reducer';

const rootReducer = () => ({
	notificationReducer,
	notificationsReducer,

	addWysiwygImageModalReducer,
	addWysiwygVideoModalReducer,
	addWysiwygAnswerModalReducer,
	addWysiwygFormulaModalReducer,
	adminPlaylistReducer,
	adminInstructionReducer,

	profileReducer,
	subjectsReducer,
	subjectDetailsReducer,
	topicsReducer,
	episodesReducer,
	episodeDetailsReducer,
	roomDetailsReducer,
	manageSubjectReducer,
	manageCategoryReducer,
	manageSubcategoryReducer,
	manageTopicReducer,
	manageEpisodeReducer,
	managePlaylistReducer,
	manageDifficultyReducer,

	sidebarReducer,
});

export default rootReducer;
